import {
  ApiBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
  githubAuthApiRef,
} from '@backstage/core-plugin-api';
import {
  AiReadinessFixClient,
  aiReadinessFixApiRef,
} from './api/aiReadinessFixApi';

export const rithumAiReadinessPlugin = createFrontendPlugin({
  pluginId: 'rithum-ai-readiness',
  extensions: [
    ApiBlueprint.make({
      name: 'ai-readiness-fix',
      params: params =>
        params({
          api: aiReadinessFixApiRef,
          deps: {
            discoveryApi: discoveryApiRef,
            fetchApi: fetchApiRef,
            githubAuthApi: githubAuthApiRef,
          },
          factory: ({ discoveryApi, fetchApi, githubAuthApi }) =>
            new AiReadinessFixClient(discoveryApi, fetchApi, githubAuthApi),
        }),
    }),
  ],
});
